import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faFileEdit, faTrashAlt, faAngleLeft, faAngleRight, faBoxArchive, faFileCsv, faSpinner } from "@fortawesome/free-solid-svg-icons";
import AddJob from "../modal/jdl-modals/published-archives/addJob";
import React, { useState, useEffect, ChangeEvent } from "react";
import Modal from "../modal/modal";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { GET_JDL_MONTH_YEAR_END_POINT, SET_JDL_PUBLISH_STAT_END_POINT, SEARCH_ROLES_END_POINT, UPLOAD_CSV_END_POINT } from "../../../config/config";
import { jdlResultProps } from "../../../utils/types";
import { AxiosError } from "axios";
import { Notification } from "../pop-ups/notification";
import DeleteJdl from "../modal/jdl-modals/published-archives/deleteJdl";
import { months } from "../../../utils/time.date.utlis";
import UpdateRequirements from "../modal/jdl-modals/published-archives/UpdateRequirement";

export default function Published() {

    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();

    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [year, setYear] = useState<number>(currentYear);
    const [month, setMonth] = useState<number>(currentMonth);
    const [jdlResults, setJdlResults] = useState<jdlResultProps[]>([]);
    const [search, setSearch] = useState('');
    const [showNotif, setShowNotif] = useState<boolean>(false);
    const [notifValue, setNotifValue] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
    const [dataIsLoading, setDataIsLoading] = useState<boolean>(true);
    const [searchRoleKey, setSearchRoleKey] = useState<string>(''); 
    const [csvFile, setCsvFile] = useState<File | null>(null);
    const [csvBtnLoading, setCsvButtonLoading] = useState<boolean>(false);

    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }

    function handleSearch (e : ChangeEvent<HTMLInputElement>){
        setSearch(e.target.value);
    }

    const jdlData = jdlResults.filter((data)=>
        data.position_title.toLowerCase().includes(search.toLowerCase()) ||
        data.client_name.toLowerCase().includes(search.toLowerCase()) ||
        data.domain_name.toLowerCase().includes(search.toLowerCase()) ||
        data.segment_name.toLowerCase().includes(search.toLowerCase()) ||
        data.segment_name.toLowerCase().includes(search.toLowerCase()) ||
        data.status.toLowerCase().includes(search.toLowerCase())
    );

    function incrementMonth(){
        let index = month;
        index++;
        setMonth(index < 12 ? index : 0);
        setDataIsLoading(true);
    }

    function decrementMonth(){
        let index = month;
        index--;
        setMonth(index === -1 ? 11 : index);
        setDataIsLoading(true);
    }
    
    const incrementYear = () => {
        setYear(year + 1);
        setDataIsLoading(true);
    }

    const decrementYear = () => {
        setYear(year - 1);
        setDataIsLoading(true);
    }

    useEffect(()=>{
        if(searchRoleKey === ''){
            const loadJdl = async() => {
                try{
                    const jdl = await api.get(GET_JDL_MONTH_YEAR_END_POINT+year+'/'+(month+1),{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    })
                    setJdlResults(jdl.data);
                    setDataIsLoading(false);
                }catch(e){
                    setDataIsLoading(false);
                }
            }
            loadJdl();
        }
    },[year, month, showModal, isSuccess, searchRoleKey])

    useEffect(()=>{
        if(searchRoleKey !== '' && searchRoleKey.length >= 3){
            setDataIsLoading(true);
            const loadRoles = async() => {
                try{
                    const jdl = await api.post(SEARCH_ROLES_END_POINT,
                        {key_arr : searchRoleKey},
                        {
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    });
                    setJdlResults(jdl.data);
                    setDataIsLoading(false);
                }catch(e){
                    setDataIsLoading(false);
                }
            }
            loadRoles();
        }
    },[searchRoleKey])

    useEffect(()=>{
        const uploadCsvFile = async() => {
            if(!csvFile) return;
            setCsvButtonLoading(true);
            const formData = new FormData();

            formData.append('file', csvFile);
           
            try{
                await api.post(UPLOAD_CSV_END_POINT, formData, {
                    headers : {
                        'Authorization' : 'Bearer '+getToken()
                    }
                });
                setShowNotif(true)
                setIsSuccess(true);
                setNotifValue('Roles updated.');
                setCsvButtonLoading(false);
                setCsvFile(null);
            }catch(e){
                const error = (e as AxiosError);
                const err_stat = error.response?.status;

                let msg = '';
                switch(err_stat){
                    case 401:
                        msg = 'Unauthorized access. Please relogin.';
                        break;
                    case 417:
                        msg = 'Roles already up to date.';
                        break;
                    default:
                        msg = 'Failed to update roles.';
                        break;
                }
                setShowNotif(true)
                setIsSuccess(false);
                setNotifValue(msg);
                setCsvFile(null);
                setCsvButtonLoading(false);
            }
            setTimeout(()=>{
                setIsSuccess(null)
                setShowNotif(false)
            },3000)
            
        }
        uploadCsvFile();
    }, [csvFile]);

    function archiveJdl (id : number){
        setShowNotif(true);
        setNotifValue('Processing....');

        setTimeout(async()=>{
            try{
                await api.patch(SET_JDL_PUBLISH_STAT_END_POINT,{
                    id : [id],
                    publish_stat : 'No'
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setIsSuccess(true);
                setNotifValue('JDL Archived!');
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setIsSuccess(false);
                    setNotifValue('Unauthorized access!')
                }else{
                    setIsSuccess(false);
                    setNotifValue('An error occured!')
                }
            }
            
            setTimeout(()=>{
                setIsSuccess(null)
                setShowNotif(false)
            },1000)    
        }, 500)
    }

    const handleCsvUpload = (e : ChangeEvent<HTMLInputElement>) => {
        const csv = e.target.files;
        if(csv && csv.length > 0) {
            if(csv[0].type === 'text/csv'){
                setCsvFile(csv[0]);
            }else{
                alert('Invalid file type');
            }            
        }
    }
 
    return (
        <div>
            <div className="w-full bg-white px-2 py-4">
                <h1 className="text-md">
                    Database Roles
                </h1>
            </div>
            <div className='w-full flex justify-center gap-8 bg-white px-2 py-2'>

                <div className="flex gap-4 text-xl text-gray-700">
                    <div>
                        <button className="hover:text-orange-500" onClick={decrementYear}>
                            <FontAwesomeIcon icon={faAngleLeft} />
                        </button>
                    </div>
                    <div>
                        {year}
                    </div>
                    <div>
                        <button className="hover:text-orange-500" onClick={incrementYear}>
                            <FontAwesomeIcon icon={faAngleRight} />
                        </button>
                    </div>
                </div>

                <div className="flex w-full">
                    <div className="flex gap-4 w-40 text-xl text-gray-700">
                        <div>
                            <button onClick={decrementMonth} className="hover:text-orange-500">
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </button>
                        </div>
                        <div className="w-24 text-center">
                            {months[month]}
                        </div>
                        <div className="ms-auto">
                            <button onClick={incrementMonth} className="hover:text-orange-500">
                                <FontAwesomeIcon icon={faAngleRight} />
                            </button>
                        </div>
                    </div>
                    <div className="ms-auto">
                        <input type="text" onChange={(e)=>setSearchRoleKey(e.target.value)} className='text-box' placeholder="Search all roles...." />
                    </div>
                </div>

            </div>
            <div className='w-full flex items-center bg-white px-2 py-4'>
                <div>
                    <input type="text" onChange={handleSearch} value={search} className='text-box' placeholder="Search monthly roles...." />
                </div>
                <div className='ms-auto flex gap-6'>
                    <div>
                        {csvBtnLoading ? (
                            <label className='button button-vcc-green bg-green-400 hover:bg-green-400 cursor-not-allowed text-sm px-8'>
                                <FontAwesomeIcon icon={faSpinner} className="animate-spin" />&nbsp;
                                Processing csv....
                            </label>
                        ) : (
                            <>
                                <label htmlFor="csv_upload" className='button button-vcc-green text-sm px-8 cursor-pointer'>
                                    <FontAwesomeIcon icon={faFileCsv} />&nbsp;
                                    Dump CSV
                                </label>
                                <input type='file' id="csv_upload" accept="text/csv" onChange={handleCsvUpload} className="hidden" />
                            </>
                        )}
                        
                    </div>
                    <div>
                        <button className='button button-vcc-primary text-sm px-4' onClick={()=>createModalContent(<AddJob />)} type="button">
                            <FontAwesomeIcon icon={faPlus} />&nbsp;
                            New Job
                        </button>
                    </div>
                </div>
            </div>
            <div className='table-container'>
                <table className="w-full border">
                    <thead className="table-fixed-header border">
                        <tr>
                            <th className='table-headers'>#</th>
                            <th className='table-headers'>Position Title</th>
                            <th className='table-headers'>Client</th>
                            <th className='table-headers'>Domain</th>
                            <th className='table-headers'>Segment</th>
                            <th className='table-headers'>Sub-Segment</th>
                            <th className='table-headers'>Status</th>
                            <th className='table-headers'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {dataIsLoading ? (
                            <>
                                <tr className="">
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                </tr>
                            </>
                        ) : (
                            <>
                                {jdlResults.length > 0 ? (
                                    <>
                                        {jdlData.map((value, index)=>(
                                            <tr className="hover:bg-gray-300">
                                                <td className='table-body px-2'>{index + 1}</td>
                                                <td className='table-body px-2'>{value.position_title}</td>
                                                <td className='table-body px-2'>{value.client_name}</td>
                                                <td className='table-body px-2'>{value.domain_name}</td>
                                                <td className='table-body px-2'>{value.segment_name}</td>
                                                <td className='table-body px-2'>{value.sub_segment_name}</td>
                                                <td className='table-body px-2'>{value.status}</td>
                                                <td className='table-body px-2'>
                                                    <div className='flex gap-4 justify-center items-center'>
                                                        <i onClick={() => createModalContent(<UpdateRequirements id={value.id} />)} className="cursor-pointer text-blue-500">
                                                            <FontAwesomeIcon icon={faFileEdit} />
                                                        </i>
                                                        <i onClick={()=>archiveJdl(value.id)} className="cursor-pointer text-gray-600">
                                                            <FontAwesomeIcon icon={faBoxArchive} />
                                                        </i>
                                                        <i onClick={()=>createModalContent(<DeleteJdl id={[value.id]} name={value.position_title} />)} className="cursor-pointer text-red-500">
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </i>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        <tr className="hover:bg-gray-300">
                                            <td colSpan={8} className='table-body'>No Role Found.</td>
                                        </tr>
                                    </>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </div>
            {showModal &&(
                <Modal onClose={()=>setShowModal(false)}> 
                    {modalChildren}
                </Modal>
            )}
            {showNotif && (
                <Notification notif={notifValue} success={isSuccess} />
            )}
        </div>
    );
}